import {
  Directive,
  ElementRef,
  HostListener,
  inject,
  output,
} from '@angular/core'

@Directive({ selector: '[dhpClickOutside]' })
export class ClickOutsideDirective {
  private elementRef = inject(ElementRef)

  readonly clickOutside = output()

  @HostListener('document:click', ['$event'])
  onClick(event: MouseEvent): void {
    const targetElement = event.target as Element
    const clickedInside = this.elementRef.nativeElement.contains(targetElement)

    if (!clickedInside) {
      // TODO: The 'emit' function requires a mandatory void argument
      this.clickOutside.emit()
    }
  }
}
